import { CampaignMembership } from "@/types";

type PermissionsState = {
  loading: boolean;
  memberships: CampaignMembership[];
  is_admin: boolean;
  is_staff: boolean;
  is_superuser: boolean;
  mfa_enabled: boolean;
  mfa_required: boolean;  
}

const defaultState = {
  loading: true,
  memberships: [],
  is_admin: false,
  is_staff: false,
  is_superuser: false,
  mfa_required: false,
  mfa_enabled: false,
};

const permissions = function (state:PermissionsState = defaultState, action:any) {

  switch (action.type) {
    case "SET_MEMBERSHIPS":
      const {memberships, account} = action;
      const profile = account?.profile || {};
      return {
        ...state,
        loading: false,
        is_admin: memberships ? memberships.some(m => m.role.name === 'admin') : false,
        is_staff: !!account?.is_staff,
        is_superuser: !!account?.is_superuser,
        memberships,
        ...profile
      };
    default:
      return state;
  }
};

export default permissions;
